import $api from "@/api/jobs.js"
import {getCookie} from '@/tools/cookie'
import {stateOptions} from '@/tools/formData.js';
import mixpanel from '@/utils/mixpanel.js';
export default {
  data() {
    return {
      jobList: [],
      loadedJobsLists: [],
      loading: true,
      firstLoading: false,
      total: 0,
      more: true,
      query: {
        state: '',
        pageSize: 5,
        page: 0
      },
      state: {
        label: 'All States',
        value: 'All States'
      },
      display: true,
      contenHeight: 700,
      icons: [
        {
          src: require('@/assets/icon/ic_location.svg'),
          alt: "icon-view-poi",
          width: "",
        },
        {
          src: require('@/assets/icon/ic-jobs-empty-state.svg'),
          alt: "empty-state"
        }
      ],
      JobBoard: `${process.env.VUE_APP_JOB_Link}/job-board`,
      isFixed: false
    }
  },
  methods: {
    async search(type='search') {
      this.loading = true;
      const query = this.query;
      const params = Object.assign({}, query);
      const [err, res] = await $api.getRecommendJob(params);
      this.loading = false;
      if (!err) {
        // 如果是根据条件进行搜索，那么本次搜索会清除上一次的结果。
        // 如果是滑动到底部进行翻页，那么展示的结果应该是上一次的结果加上本次的搜索结果。
        const loadedJobsLists = type === 'search' ? [] : this.loadedJobsLists;
        this.jobList = res.data.data.resultList;
        this.loadedJobsLists = loadedJobsLists.concat(this.jobList);
        this.total = res.data.data.total;
        this.more = res.data.data.more;
      }
    },
    filter(state) {
      this.query.page = 0;
      this.query.state = state;
      this.display = true;
      this.loadedJobsLists = [];
      const target = stateOptions.find(elem => elem.value === state);
      if (target) {
        this.state = target;
      } else {
        this.state = {
          label: 'All States',
          value: 'All States'
        }
      }
      this.search()
    },
    currentLocation() {
      const that = this;
      const longitude = getCookie('longitude') || -1;
      const latitude = getCookie('latitude') || -1;
      if (longitude === -1 && latitude === -1) {
        that.filter();
        return;
      }
      $api.resolveLocation(longitude, latitude).then(res => {
        that.state = res;
        that.filter(that.state.value);
      }, (err) => {
        that.state = err;
        that.filter(that.state.value);
      });
    },
    async load() {
      // 只在loading为false时触发，防止在请求数据过程中多次触发
      if (!this.loading && this.more) {
        this.loading = true
        this.query.page++
        await this.search('turnPage')
        this.loading = false
      }
    },
    switchFilter() {
      const filter = this.$refs.mobileFilter;
      if (filter) {
        filter.drawer = true;
        this.display = false;
        mixpanel.track('Discover Page', {
          'Outcome': 'Click on Filter',
        });
      }
    },
    fixed(value) {
      this.isFixed = value;
    }
  },
  mounted() {
    this.currentLocation();
  }
}
